/* Постачальники й рахунки (/supply, batch B7). Kept apart from uk.ts/en.ts to keep merges small. */
export const supplyUk = {
  'nav.supply': 'Постачальники й рахунки',
  'permGroup.supply': 'Постачальники й рахунки',
  'perm.invoices.submit': 'Накладні: реєстрація (фото, номер), без сум',
  'perm.invoices.manage': 'Постачальники, розбіжності, оприбуткування, акти звірки',
  'perm.invoices.pay': 'Накладні: суми, борг і підтвердження оплати (фінансист)',
  'process.area.supply': 'Постачання',
  'supply.title': 'Постачальники й рахунки',
  'supply.subtitle': 'Накладні з таймером оплати 24 год, картки постачальників і акти звірки. Час — київський.',
  'supply.tabInvoices': 'Накладні',
  'supply.tabSuppliers': 'Постачальники',
  'supply.tabActs': 'Акти звірки',
  'supply.register': 'Зареєструвати накладну',
  'supply.registerTitle': 'Нова накладна',
  'supply.registerHint': 'Сфотографуйте накладну, оберіть філію — номер присвоїться автоматично. Напишіть його на документі.',
  'supply.registerButton': 'Зареєструвати',
  'supply.registered': 'Накладна №{n} зареєстрована — напишіть номер на документі',
  'supply.photo': 'Фото або PDF',
  'supply.photoHint': 'Можна кілька сторінок. До 10 МБ кожен файл.',
  'supply.chooseBranch': 'Оберіть філію',
  'supply.needBranch': 'Оберіть філію: нумерація окрема для Харкова і Києва.',
  'supply.needPhoto': 'Додайте фото накладної або вкажіть постачальника.',
  'supply.badAmount': 'Сума — число, наприклад 1250,50',
  'supply.supplier': 'Постачальник',
  'supply.supplierOther': 'Немає в списку / не знаю',
  'supply.supplierHint': 'Постачальник (як на документі)',
  'supply.supplierName': 'Назва',
  'supply.noSupplier': 'Постачальника не вказано',
  'supply.payer': 'ФОП-платник',
  'supply.payers': 'ФОП-платники',
  'supply.defaultPayer': 'ФОП-платник за замовчуванням',
  'supply.docNumber': '№ документа постачальника',
  'supply.docDate': 'Дата документа',
  'supply.amount': 'Сума до сплати',
  'supply.note': 'Примітка',
  'supply.noteHint': 'Наприклад, чого не вистачило під час приймання.',
  'supply.notes': 'Нотатки',
  'supply.searchPlaceholder': 'Номер, постачальник, № документа',
  'supply.onlyOverdue': 'Лише прострочені',
  'supply.onlyMine': 'Лише мої',
  'supply.totalOpen': 'Не оплачено',
  'supply.totalOverdue': 'Прострочено',
  'supply.totalDiscrepancies': 'З розбіжностями',
  'supply.totalNotPosted': 'Не оприбутковано',
  'supply.empty': 'Накладних ще немає',
  'supply.emptyHint': 'Сфотографуйте накладну тут або надішліть /invoice робочому боту в Telegram — вона з’явиться на дошці з таймером оплати.',
  'supply.status.received': 'Отримано',
  'supply.status.discrepancy': 'Розбіжність',
  'supply.status.posted': 'Оприбутковано',
  'supply.status.paid': 'Оплачено',
  'supply.status.cancelled': 'Скасовано',
  'supply.columnEmpty.received': 'Нових накладних немає',
  'supply.columnEmpty.discrepancy': 'Розбіжностей немає',
  'supply.columnEmpty.posted': 'Усе оприбутковане оплачено',
  'supply.columnEmpty.paid': 'За 30 днів нічого не оплачено',
  'supply.timer.left': 'залишилось {span}',
  'supply.timer.overdue': 'прострочено {span}',
  'supply.timer.paid': 'оплачено',
  'supply.span.d': '{n} дн',
  'supply.span.h': '{n} год',
  'supply.span.m': '{n} хв',
  'supply.notPosted': 'не оприбутковано',
  'supply.files': 'Файли',
  'supply.receivedShort': 'Отримано {when} · {who}',
  'supply.numbering': 'Нумерація',
  'supply.numberingHint': 'Наступний номер накладної для кожної філії. Щоб продовжити нумерацію з таблиці «НАКЛАДНІ», вкажіть наступний вільний номер.',
  'supply.nextNumber': 'Наступний номер — {branch}',
  'supply.lastUsed': 'Останній використаний: {n}',
  'supply.numberingSaved': 'Нумерацію збережено',
  'supply.invoiceTitle': 'Накладна №{n} · {branch}',
  'supply.byWhom': '{when} · {who}',
  'supply.received': 'Отримано',
  'supply.payDue': 'Оплатити до',
  'supply.postedLabel': 'Оприбутковано в Enote',
  'supply.paidLabel': 'Оплачено',
  'supply.notYet': 'ще ні',
  'supply.paymentRef': 'Платіжка / примітка',
  'supply.paymentMethod': 'Спосіб оплати',
  'supply.method.bank': 'Безготівка',
  'supply.method.cash': 'Готівка',
  'supply.enoteDoc': 'Документ Enote',
  'supply.cancelReason': 'Причина скасування',
  'supply.escalated': 'Ескальовано власнику',
  'supply.fromSheet': 'Історія з таблиці «Накладні»',
  'supply.sheetUnpaid': 'У таблиці не відмічено оплату',
  'supply.unpost': 'Зняти «оприбутковано»',
  'supply.confirmPosted': 'Оприбутковано в Enote',
  'supply.confirmPaid': 'Підтвердити оплату',
  'supply.unpay': 'Скасувати оплату',
  'supply.unpayTitle': 'Скасувати позначку «оплачено»?',
  'supply.addFiles': 'Додати файли',
  'supply.noFiles': 'Файлів немає. Додайте фото накладної, видаткової або платіжки.',
  'supply.fileKind': 'Тип документа',
  'supply.fileKind.invoice': 'Рахунок / накладна',
  'supply.fileKind.delivery_note': 'Видаткова накладна',
  'supply.fileKind.payment': 'Платіжка',
  'supply.fileKind.other': 'Інше',
  'supply.discrepancies': 'Розбіжності',
  'supply.noDiscrepancies': 'Розбіжностей немає. Якщо товару не вистачає чи прийшло не те — зафіксуйте розбіжність.',
  'supply.addDiscrepancy': 'Розбіжність',
  'supply.discrepancyHint': 'Менеджер з постачання отримає чекліст і сповіщення.',
  'supply.discrepancyKind': 'Що не так',
  'supply.discrepancyText': 'Опис',
  'supply.discrepancyPlaceholder': 'Позиція, скільки очікували і скільки прийшло',
  'supply.disc.shortage': 'Нестача',
  'supply.disc.wrong_item': 'Пересорт',
  'supply.disc.damaged': 'Пошкодження',
  'supply.disc.price': 'Ціна',
  'supply.disc.other': 'Інше',
  'supply.openChecklist': 'Чекліст',
  'supply.resolution': 'Як вирішено',
  'supply.resolutionHint': 'Дошлють, коригувальна накладна, повернення…',
  'supply.resolve': 'Закрити розбіжність',
  'supply.history': 'Історія',
  'supply.event.received': 'Зареєстровано',
  'supply.event.updated': 'Змінено',
  'supply.event.file': 'Додано файл',
  'supply.event.discrepancy': 'Розбіжність',
  'supply.event.resolved': 'Розбіжність закрито',
  'supply.event.posted': 'Оприбутковано',
  'supply.event.unposted': 'Знято «оприбутковано»',
  'supply.event.paid': 'Оплачено',
  'supply.event.unpaid': 'Оплату скасовано',
  'supply.event.cancelled': 'Скасовано',
  'supply.cancelInvoice': 'Скасувати накладну',
  'supply.cancelTitle': 'Скасувати накладну №{n}? Номер не буде використано повторно.',
  'supply.reason': 'Причина',
  'supply.editTitle': 'Накладна №{n}',
  'supply.matchHint': 'Документи надходження з Enote поруч за датою; найближчі за сумою — першими. Оберіть свій або підтвердьте без документа.',
  'supply.noMatches': 'Документів надходження поруч за датою не знайдено. Можна підтвердити без документа.',
  'supply.confirmWithDoc': 'Підтвердити з документом',
  'supply.confirmWithoutDoc': 'Підтвердити без документа',
  'supply.match.exact': 'сума збігається',
  'supply.match.close': 'сума близька',
  'supply.match.different': 'інша сума',
  'supply.match.unknown': 'суму не вказано',
  'supply.linkedTo': 'уже в №{n}',
  'supply.matchLines': 'рядків: {n} · днів різниці: {days}',
  'supply.paidAt': 'Коли оплачено',
  'supply.paidHint': 'Оплату підтверджує фінансист. Додайте скрін платіжки, якщо є.',
  'supply.paymentFile': 'Скрін / платіжка',
  'supply.paidSaved': 'Оплату підтверджено',
  'supply.showArchived': 'Показати архівних',
  'supply.addSupplier': 'Додати постачальника',
  'supply.editSupplier': 'Картка постачальника',
  'supply.noSuppliers': 'Постачальників ще немає',
  'supply.noSuppliersHint': 'Додайте постачальників (назва, ЄДРПОУ, ФОП-платники, відстрочка) — накладні й акти звірки прив’яжуться до них.',
  'supply.terms': 'Оплата',
  'supply.terms24': '24 год',
  'supply.termsDays': 'відстрочка {n} дн',
  'supply.termsDaysLabel': 'Відстрочка оплати, днів',
  'supply.termsHint': '0 — діє норма клініки: 24 години.',
  'supply.openInvoices': 'Неоплачені',
  'supply.overdueN': 'прострочено: {n}',
  'supply.unpaid': 'Борг',
  'supply.unpaidN': 'Неоплачені',
  'supply.lastSigned': 'Підписаний акт',
  'supply.noSignedAct': 'немає',
  'supply.contractEnds': 'Договір до',
  'supply.edrpou': 'ЄДРПОУ',
  'supply.edrpouShort': 'ЄДРПОУ {v}',
  'supply.edrpouHint': 'Код компанії, 8 цифр. ІПН фізосіб не вносимо.',
  'supply.reconcile': 'Щоквартальний акт звірки',
  'supply.active': 'Активний',
  'supply.archived': 'В архіві',
  'supply.enoteRef': 'Контрагент Enote (GUID)',
  'supply.enoteRefHint': 'Необов’язково: для майбутнього зіставлення з Enote.',
  'supply.contacts': 'Контакти представників',
  'supply.contactsHint': 'Лише робочі контакти компанії (менеджер, бухгалтерія).',
  'supply.contact.name': 'Ім’я',
  'supply.contact.role': 'Роль',
  'supply.contact.phone': 'Телефон',
  'supply.contact.email': 'E-mail',
  'supply.addContact': 'Додати контакт',
  'supply.contracts': 'Договори',
  'supply.noContracts': 'Договорів немає.',
  'supply.addContract': 'Додати договір',
  'supply.editContract': 'Договір',
  'supply.contractNumber': '№ договору',
  'supply.contractNoNumber': 'Без номера',
  'supply.contractFiles': 'Скан договору',
  'supply.contractExpiring': 'закінчується',
  'supply.openEnded': 'безстроковий',
  'supply.startsOn': 'Діє з',
  'supply.endsOn': 'Діє до',
  'supply.fileN': 'файл {n}',
  'supply.months': 'Документи по місяцях',
  'supply.noMonths': 'За рік накладних немає.',
  'supply.month': 'Місяць',
  'supply.noActsSupplier': 'Актів звірки ще не було.',
  'supply.signed': 'підписано',
  'supply.signedBoth': 'Підписано з обох сторін',
  'supply.period': 'Період',
  'supply.allPeriods': 'Усі періоди',
  'supply.quarter': '{q} кв. {y}',
  'supply.year': '{y} рік',
  'supply.onlyOpenActs': 'Лише незакриті',
  'supply.generate': 'Запросити акти за минулий квартал',
  'supply.generated': 'Нових запитів актів: {n} ({period})',
  'supply.requestAct': 'Запросити акт',
  'supply.requestActHint': 'Для року — щорічний акт із двостороннім підписом. Створиться чекліст фінансисту.',
  'supply.noActs': 'Актів звірки немає',
  'supply.noActsHint': 'З 5-го числа кожного кварталу акти за попередній квартал запитуються автоматично для кожного активного постачальника.',
  'supply.actStatus': 'Статус',
  'supply.checklist': 'Чекліст',
  'supply.difference': 'Розбіжність, грн',
  'supply.differenceHint': 'Сума розбіжності за актом (з мінусом, якщо на нашу користь).',
  'supply.actFiles': 'Файли акта',
  'supply.filesAttached': 'Уже додано файлів: {n}',
  'supply.requestedAt': 'запит {when}',
  'supply.actTitle': 'Акт звірки: {supplier}, {period}',
  'supply.recon.requested': 'Запитано',
  'supply.recon.received': 'Отримано',
  'supply.recon.disputed': 'Є розбіжності',
  'supply.recon.closed': 'Закрито',
  'supply.runOpen': 'відкрити',
  'supply.runOverdue': 'прострочено',
  'supply.runDone': 'виконано',
  'supply.runClosed': 'закрито',
  'today.invoicesOverdue': 'Накладні не оплачено вчасно',
  'today.invoicesOverdueHint': 'Прострочено: {n}. Відкрийте «Постачальники й рахунки».',
  'supply.noOverdue': 'Усі накладні оплачуються вчасно',
}

export const supplyEn: { [K in keyof typeof supplyUk]?: string } = {
  'nav.supply': 'Suppliers & invoices',
  'permGroup.supply': 'Suppliers & invoices',
  'perm.invoices.submit': 'Invoices: register (photo, number), no amounts',
  'perm.invoices.manage': 'Suppliers, discrepancies, posting, reconciliation acts',
  'perm.invoices.pay': 'Invoices: amounts, balances and payment confirmation (finance)',
  'process.area.supply': 'Supply',
  'supply.title': 'Suppliers & invoices',
  'supply.subtitle': 'Invoices with the 24 h payment timer, supplier cards and reconciliation acts. Kyiv time.',
  'supply.tabInvoices': 'Invoices',
  'supply.tabSuppliers': 'Suppliers',
  'supply.tabActs': 'Reconciliation acts',
  'supply.register': 'Register invoice',
  'supply.registerTitle': 'New invoice',
  'supply.registerHint': 'Take a photo of the invoice and choose the branch — the number is assigned automatically. Write it on the document.',
  'supply.registerButton': 'Register',
  'supply.registered': 'Invoice #{n} registered — write the number on the document',
  'supply.photo': 'Photo or PDF',
  'supply.photoHint': 'Several pages are fine. Up to 10 MB per file.',
  'supply.chooseBranch': 'Choose a branch',
  'supply.needBranch': 'Choose the branch: Kharkiv and Kyiv are numbered separately.',
  'supply.needPhoto': 'Add a photo of the invoice or name the supplier.',
  'supply.badAmount': 'Amount must be a number, e.g. 1250.50',
  'supply.supplier': 'Supplier',
  'supply.supplierOther': 'Not in the list / unknown',
  'supply.supplierHint': 'Supplier (as on the document)',
  'supply.supplierName': 'Name',
  'supply.noSupplier': 'No supplier yet',
  'supply.payer': 'Payer (ФОП)',
  'supply.payers': 'Payers (ФОП)',
  'supply.defaultPayer': 'Default payer',
  'supply.docNumber': 'Supplier document #',
  'supply.docDate': 'Document date',
  'supply.amount': 'Amount due',
  'supply.note': 'Note',
  'supply.noteHint': 'E.g. what was missing at receipt.',
  'supply.notes': 'Notes',
  'supply.searchPlaceholder': 'Number, supplier, document #',
  'supply.onlyOverdue': 'Overdue only',
  'supply.onlyMine': 'Mine only',
  'supply.totalOpen': 'Unpaid',
  'supply.totalOverdue': 'Overdue',
  'supply.totalDiscrepancies': 'With discrepancies',
  'supply.totalNotPosted': 'Not posted',
  'supply.empty': 'No invoices yet',
  'supply.emptyHint': 'Photograph an invoice here or send /invoice to the staff Telegram bot — it appears on the board with its payment timer.',
  'supply.status.received': 'Received',
  'supply.status.discrepancy': 'Discrepancy',
  'supply.status.posted': 'Posted',
  'supply.status.paid': 'Paid',
  'supply.status.cancelled': 'Cancelled',
  'supply.columnEmpty.received': 'No new invoices',
  'supply.columnEmpty.discrepancy': 'No discrepancies',
  'supply.columnEmpty.posted': 'Everything posted is paid',
  'supply.columnEmpty.paid': 'Nothing paid in 30 days',
  'supply.timer.left': '{span} left',
  'supply.timer.overdue': 'overdue {span}',
  'supply.timer.paid': 'paid',
  'supply.span.d': '{n} d',
  'supply.span.h': '{n} h',
  'supply.span.m': '{n} min',
  'supply.notPosted': 'not posted',
  'supply.files': 'Files',
  'supply.receivedShort': 'Received {when} · {who}',
  'supply.numbering': 'Numbering',
  'supply.numberingHint': 'Next invoice number per branch. To continue the «НАКЛАДНІ» sheet, enter its next free number.',
  'supply.nextNumber': 'Next number — {branch}',
  'supply.lastUsed': 'Last used: {n}',
  'supply.numberingSaved': 'Numbering saved',
  'supply.invoiceTitle': 'Invoice #{n} · {branch}',
  'supply.received': 'Received',
  'supply.payDue': 'Pay by',
  'supply.postedLabel': 'Posted in Enote',
  'supply.paidLabel': 'Paid',
  'supply.notYet': 'not yet',
  'supply.paymentRef': 'Payment order / note',
  'supply.paymentMethod': 'Payment method',
  'supply.method.bank': 'Bank transfer',
  'supply.method.cash': 'Cash',
  'supply.enoteDoc': 'Enote document',
  'supply.cancelReason': 'Cancel reason',
  'supply.escalated': 'Escalated to the owner',
  'supply.fromSheet': 'History from the «Накладні» sheet',
  'supply.sheetUnpaid': 'Not marked paid in the sheet',
  'supply.unpost': 'Undo «posted»',
  'supply.confirmPosted': 'Posted in Enote',
  'supply.confirmPaid': 'Confirm payment',
  'supply.unpay': 'Revert payment',
  'supply.unpayTitle': 'Revert «paid»?',
  'supply.addFiles': 'Add files',
  'supply.noFiles': 'No files. Add a photo of the invoice, delivery note or payment.',
  'supply.fileKind': 'Document type',
  'supply.fileKind.invoice': 'Invoice',
  'supply.fileKind.delivery_note': 'Delivery note',
  'supply.fileKind.payment': 'Payment',
  'supply.fileKind.other': 'Other',
  'supply.discrepancies': 'Discrepancies',
  'supply.noDiscrepancies': 'No discrepancies. If goods are missing or wrong, record a discrepancy.',
  'supply.addDiscrepancy': 'Discrepancy',
  'supply.discrepancyHint': 'The purchasing manager gets a checklist and a notification.',
  'supply.discrepancyKind': 'What is wrong',
  'supply.discrepancyText': 'Description',
  'supply.discrepancyPlaceholder': 'Item, expected and received quantity',
  'supply.disc.shortage': 'Shortage',
  'supply.disc.wrong_item': 'Wrong item',
  'supply.disc.damaged': 'Damaged',
  'supply.disc.price': 'Price',
  'supply.disc.other': 'Other',
  'supply.openChecklist': 'Checklist',
  'supply.resolution': 'Resolution',
  'supply.resolutionHint': 'Will be delivered, credit note, return…',
  'supply.resolve': 'Close discrepancy',
  'supply.history': 'History',
  'supply.event.received': 'Registered',
  'supply.event.updated': 'Edited',
  'supply.event.file': 'File added',
  'supply.event.discrepancy': 'Discrepancy',
  'supply.event.resolved': 'Discrepancy closed',
  'supply.event.posted': 'Posted',
  'supply.event.unposted': '«Posted» undone',
  'supply.event.paid': 'Paid',
  'supply.event.unpaid': 'Payment reverted',
  'supply.event.cancelled': 'Cancelled',
  'supply.cancelInvoice': 'Cancel invoice',
  'supply.cancelTitle': 'Cancel invoice #{n}? The number is not reused.',
  'supply.reason': 'Reason',
  'supply.editTitle': 'Invoice #{n}',
  'supply.matchHint': 'Enote goods receipts near the invoice date, closest amount first. Pick yours or confirm without a document.',
  'supply.noMatches': 'No Enote receipts near this date. You can confirm without a document.',
  'supply.confirmWithDoc': 'Confirm with document',
  'supply.confirmWithoutDoc': 'Confirm without document',
  'supply.match.exact': 'amount matches',
  'supply.match.close': 'amount close',
  'supply.match.different': 'other amount',
  'supply.match.unknown': 'no amount',
  'supply.linkedTo': 'already #{n}',
  'supply.matchLines': 'lines: {n} · days apart: {days}',
  'supply.paidAt': 'Paid at',
  'supply.paidHint': 'Finance confirms the payment. Attach the payment screenshot if you have it.',
  'supply.paymentFile': 'Payment screenshot',
  'supply.paidSaved': 'Payment confirmed',
  'supply.showArchived': 'Show archived',
  'supply.addSupplier': 'Add supplier',
  'supply.editSupplier': 'Supplier card',
  'supply.noSuppliers': 'No suppliers yet',
  'supply.noSuppliersHint': 'Add suppliers (name, company code, payers, payment terms) — invoices and reconciliation acts link to them.',
  'supply.terms': 'Payment',
  'supply.terms24': '24 h',
  'supply.termsDays': '{n}-day terms',
  'supply.termsDaysLabel': 'Payment terms, days',
  'supply.termsHint': '0 — the clinic norm applies: 24 hours.',
  'supply.openInvoices': 'Unpaid',
  'supply.overdueN': 'overdue: {n}',
  'supply.unpaid': 'Balance',
  'supply.unpaidN': 'Unpaid',
  'supply.lastSigned': 'Signed act',
  'supply.noSignedAct': 'none',
  'supply.contractEnds': 'Contract until',
  'supply.edrpou': 'Company code (ЄДРПОУ)',
  'supply.edrpouShort': 'ЄДРПОУ {v}',
  'supply.edrpouHint': 'Company code, 8 digits. No personal tax numbers.',
  'supply.reconcile': 'Quarterly reconciliation act',
  'supply.active': 'Active',
  'supply.archived': 'Archived',
  'supply.enoteRef': 'Enote contragent (GUID)',
  'supply.enoteRefHint': 'Optional: for future matching with Enote.',
  'supply.contacts': 'Representatives',
  'supply.contactsHint': 'Company work contacts only (manager, accounting).',
  'supply.contact.name': 'Name',
  'supply.contact.role': 'Role',
  'supply.contact.phone': 'Phone',
  'supply.contact.email': 'E-mail',
  'supply.addContact': 'Add contact',
  'supply.contracts': 'Contracts',
  'supply.noContracts': 'No contracts.',
  'supply.addContract': 'Add contract',
  'supply.editContract': 'Contract',
  'supply.contractNumber': 'Contract #',
  'supply.contractNoNumber': 'No number',
  'supply.contractFiles': 'Contract scan',
  'supply.contractExpiring': 'ending',
  'supply.openEnded': 'open-ended',
  'supply.startsOn': 'Valid from',
  'supply.endsOn': 'Valid until',
  'supply.fileN': 'file {n}',
  'supply.months': 'Documents by month',
  'supply.noMonths': 'No invoices in the last year.',
  'supply.month': 'Month',
  'supply.noActsSupplier': 'No reconciliation acts yet.',
  'supply.signed': 'signed',
  'supply.signedBoth': 'Signed by both sides',
  'supply.period': 'Period',
  'supply.allPeriods': 'All periods',
  'supply.quarter': '{q} quarter {y}',
  'supply.year': 'year {y}',
  'supply.onlyOpenActs': 'Open only',
  'supply.generate': 'Request last quarter’s acts',
  'supply.generated': 'New act requests: {n} ({period})',
  'supply.requestAct': 'Request act',
  'supply.requestActHint': 'A year means the yearly act signed by both sides. Finance gets a checklist.',
  'supply.noActs': 'No reconciliation acts',
  'supply.noActsHint': 'From the 5th day of each quarter the previous quarter’s acts are requested automatically for every active supplier.',
  'supply.actStatus': 'Status',
  'supply.checklist': 'Checklist',
  'supply.difference': 'Difference, UAH',
  'supply.differenceHint': 'Difference per the act (negative if in our favour).',
  'supply.actFiles': 'Act files',
  'supply.filesAttached': 'Files attached: {n}',
  'supply.requestedAt': 'requested {when}',
  'supply.actTitle': 'Reconciliation act: {supplier}, {period}',
  'supply.recon.requested': 'Requested',
  'supply.recon.received': 'Received',
  'supply.recon.disputed': 'Disputed',
  'supply.recon.closed': 'Closed',
  'supply.runOpen': 'open',
  'supply.runOverdue': 'overdue',
  'supply.runDone': 'done',
  'supply.runClosed': 'closed',
  'today.invoicesOverdue': 'Invoices not paid on time',
  'today.invoicesOverdueHint': 'Overdue: {n}. Open «Suppliers & invoices».',
  'supply.noOverdue': 'All invoices are paid on time',
}
